var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 284.8 91.1",
    style: {
      enableBackground: "new 0 0 284.8 91.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00105F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.4,32.2c2.5,1.5,3.8,3.9,2.9,5.5c-0.9,1.6-3.7,1.6-6.2,0.1c-2.5-1.5-3.8-3.9-2.9-5.5 C54.1,30.8,56.9,30.7,59.4,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,40.3c-0.5,1.8-2.6,2.7-4.6,2.1c-2-0.6-3.3-2.5-2.8-4.3c0.5-1.8,2.6-2.7,4.6-2.1 C52.2,36.6,53.4,38.5,52.9,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.2,47.4c-0.8-1.4-0.2-3.2,1.4-4.1c1.5-0.9,3.4-0.4,4.2,1c0.8,1.4,0.2,3.2-1.4,4.1 C38.8,49.2,37,48.8,36.2,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.1,56.9c-1.7,0.1-3.2-1.3-3.3-3c-0.1-1.7,1.3-3.2,3-3.3c1.7-0.1,3.2,1.3,3.3,3 C52.2,55.3,50.8,56.8,49.1,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.8,59.9c-1.5,0.1-2.8-1.3-2.8-3c-0.1-1.7,1.1-3.1,2.6-3.2c1.5-0.1,2.8,1.3,2.8,3 C63.5,58.4,62.3,59.8,60.8,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.3,57.2c-1,0.2-2.1-0.9-2.5-2.4c-0.3-1.5,0.3-3,1.3-3.2c1-0.2,2.1,0.9,2.5,2.4 C71.9,55.6,71.4,57,70.3,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.7,50.8c-0.5,0.2-1.4-0.8-1.9-2.2c-0.5-1.4-0.4-2.6,0.1-2.8c0.5-0.2,1.4,0.8,1.9,2.2 C75.3,49.3,75.3,50.6,74.7,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.8,51.7c-0.1,0-0.4-0.6-0.5-1.4c-0.2-0.8-0.2-1.5-0.1-1.5c0.1,0,0.4,0.6,0.5,1.4 C77.9,51,78,51.6,77.8,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,37.5c-0.4-1.2,0.5-2.6,2-3.1c1.6-0.6,3.2-0.1,3.6,1c0.4,1.2-0.5,2.6-2,3.1 C34,39.1,32.3,38.6,31.9,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,29.4c-0.2-0.7,1-1.6,2.5-1.9c1.5-0.3,2.9,0,3,0.8c0.2,0.7-1,1.6-2.5,1.9C35.6,30.6,34.2,30.2,34,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.6,25.1c0-0.4,1.2-0.7,2.6-0.7c1.4,0,2.6,0.3,2.6,0.7c0,0.4-1.2,0.7-2.6,0.7 C41.8,25.7,40.6,25.4,40.6,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,38.7c0.3-0.2,1,0.6,1.7,1.8c0.7,1.1,1,2.2,0.7,2.3c-0.3,0.2-1-0.6-1.7-1.8 C71.6,39.9,71.3,38.9,71.6,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.4,24.4c0-0.2,1.2-0.1,2.5,0.2c1.3,0.3,2.4,0.7,2.3,0.8c0,0.2-1.2,0.1-2.5-0.2 C50.4,24.9,49.3,24.6,49.4,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,31.9c0.1-0.1,1,0.5,1.9,1.5c0.9,0.9,1.6,1.8,1.5,1.9c-0.1,0.1-1-0.5-1.9-1.5 C66.8,32.9,66.1,32.1,66.2,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.4,26.9c0.1-0.1,1.1,0.3,2.3,1c1.2,0.6,2.1,1.2,2.1,1.3c-0.1,0.1-1.1-0.3-2.3-1 C59.3,27.6,58.4,27,58.4,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3,47.8c-1.3,1.1-3.5,0.5-4.8-1.1c-1.3-1.7-1.3-3.9,0-4.9c1.3-1.1,3.5-0.5,4.8,1.1 C63.6,44.5,63.6,46.8,62.3,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.9,31.1c-0.1,1.2-1.9,2-3.9,1.8c-2-0.2-3.6-1.3-3.5-2.6c0.1-1.2,1.9-2,3.9-1.8 C49.5,28.8,51.1,29.9,50.9,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.3,43.9c-0.9,0.7-2.5,0-3.8-1.6c-1.2-1.6-1.5-3.4-0.7-4c0.9-0.7,2.5,0,3.8,1.6 C69.8,41.4,70.1,43.2,69.3,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,29.4c-0.2,0.6-1.8,0.7-3.6,0.1c-1.8-0.6-3.1-1.6-2.8-2.2c0.2-0.6,1.8-0.7,3.6-0.1 C57.2,27.8,58.4,28.8,58.2,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.8,35.3c-0.4,0.5-1.9,0-3.3-1.2c-1.4-1.1-2.3-2.5-1.9-3c0.4-0.5,1.9,0,3.3,1.2 C66.4,33.5,67.2,34.8,66.8,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.3,68.5c-0.4,0.9-1.2,1.5-1.9,1.2c-0.7-0.3-0.9-1.2-0.5-2.2c0.4-0.9,1.2-1.5,1.9-1.2 C68.4,66.6,68.6,67.6,68.3,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,69.9c-0.7,0.8-1.9,1-2.6,0.4c-0.8-0.6-0.9-1.8-0.2-2.7c0.7-0.8,1.9-1,2.7-0.4C53.6,67.9,53.7,69,53,69.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,48c-0.7,0.8-1.7,1.1-2.4,0.6C23,48.1,23,47,23.7,46.1c0.7-0.8,1.8-1.1,2.4-0.6C26.8,46,26.7,47.1,26,48z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,35c-0.8,0.6-1.6,0.8-1.9,0.4c-0.3-0.4,0.1-1.1,0.9-1.7c0.8-0.6,1.7-0.8,1.9-0.4 C26.3,33.6,25.9,34.4,25.1,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,26.6c-0.8,0.3-1.6,0.4-1.6,0.3c-0.1-0.1,0.6-0.5,1.4-0.8c0.8-0.3,1.6-0.4,1.7-0.3 C33.5,26,32.9,26.3,32,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.7,60.6c0,0.9-0.4,1.6-0.7,1.6c-0.4,0-0.6-0.8-0.6-1.7c0-0.9,0.4-1.6,0.7-1.6 C76.4,59,76.7,59.7,76.7,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,60.6c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2C36,58.6,36.9,59.5,36.9,60.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.6,60.3L110,31.4c0.1-0.3,0.3-0.5,0.7-0.5h0.4c0.4,0,0.6,0.2,0.7,0.5l13.2,28.9c0.3,0.6-0.1,1.1-0.7,1.1 h-3.7c-0.6,0-0.9-0.3-1.2-0.9l-2.1-4.6h-12.8l-2.1,4.6c-0.2,0.4-0.6,0.9-1.2,0.9h-3.7C96.7,61.4,96.4,60.9,96.6,60.3z M115.2,51.1 l-4.3-9.4h-0.1l-4.2,9.4H115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132,32.2c0-0.4,0.3-0.8,0.8-0.8h12.3c5.2,0,9.4,4.1,9.4,9.2c0,3.9-2.6,7.2-6.4,8.7l5.9,10.9 c0.3,0.6,0,1.2-0.7,1.2h-4.5c-0.4,0-0.6-0.2-0.7-0.4l-5.7-11.4h-4.8v10.9c0,0.4-0.4,0.8-0.8,0.8h-3.9c-0.5,0-0.8-0.4-0.8-0.8V32.2 z M144.6,45.1c2.3,0,4.3-2,4.3-4.4c0-2.3-2-4.2-4.3-4.2h-7v8.5H144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.2,30.9c4.3,0,7.5,1.4,10.4,4c0.4,0.3,0.4,0.9,0,1.2l-2.6,2.7c-0.3,0.3-0.7,0.3-1.1,0 c-1.8-1.6-4.2-2.5-6.6-2.5c-5.5,0-9.6,4.6-9.6,10c0,5.4,4.1,9.9,9.6,9.9c2.6,0,4.8-1,6.6-2.4c0.3-0.3,0.8-0.3,1.1,0l2.7,2.7 c0.3,0.3,0.3,0.9,0,1.2c-2.9,2.8-6.6,4.2-10.4,4.2c-8.6,0-15.5-6.8-15.5-15.4S167.6,30.9,176.2,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.7,36.5h-6.6c-0.5,0-0.8-0.4-0.8-0.8v-3.5c0-0.4,0.3-0.8,0.8-0.8h18.8c0.5,0,0.8,0.4,0.8,0.8v3.5 c0,0.4-0.3,0.8-0.8,0.8h-6.6v24.1c0,0.4-0.4,0.8-0.8,0.8h-4c-0.4,0-0.8-0.4-0.8-0.8V36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.5,32.2c0-0.4,0.4-0.8,0.8-0.8h4c0.4,0,0.8,0.4,0.8,0.8v28.4c0,0.4-0.4,0.8-0.8,0.8h-4 c-0.4,0-0.8-0.4-0.8-0.8V32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251,30.9c4.3,0,7.5,1.4,10.4,4c0.4,0.3,0.4,0.9,0,1.2l-2.6,2.7c-0.3,0.3-0.7,0.3-1.1,0 c-1.8-1.6-4.2-2.5-6.6-2.5c-5.5,0-9.6,4.6-9.6,10c0,5.4,4.1,9.9,9.6,9.9c2.6,0,4.8-1,6.6-2.4c0.3-0.3,0.8-0.3,1.1,0l2.7,2.7 c0.3,0.3,0.3,0.9,0,1.2c-2.9,2.8-6.6,4.2-10.4,4.2c-8.6,0-15.5-6.8-15.5-15.4S242.4,30.9,251,30.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ab317ea.svg";
export { ForwardRef as ReactComponent };